/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../../../../i18n';
import { useAdminEmptyListStyles } from './AdminEmptyList.style';

export function AdminEmptyList() {
  const classes = useAdminEmptyListStyles();
  const { t } = useTranslation(Namespaces.Admin);
  return <div className={classes.emptyMessageBlock}>{t('organizations.empty_section')}</div>;
}
